(function () {
  function refresh(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('[data-product-form]').forEach(function (form) {
      var json = form.querySelector('[data-epm-selected-variant]');
      if (!json) return;
      var variant;
      try { variant = JSON.parse(json.textContent); } catch (error) { return; }
      if (window.HyperproPartNumberCoder) window.HyperproPartNumberCoder.updateForm(form, variant);
      form.dispatchEvent(new CustomEvent('theme:variant:change', { detail: { variant: variant }, bubbles: true }));
    });
    if (window.themeCustomValidation && window.themeCustomValidation.initExpedite) {
      window.themeCustomValidation.initExpedite(root);
    }
  }
  window.addEventListener('theme:section:update', function () { refresh(document); });
  document.addEventListener('shopify:section:load', function (event) { refresh(event.target); });
  document.addEventListener('DOMContentLoaded', function () { refresh(document); });
})();
